module.exports = __webpack_public_path__ + "static/media/company-select-item.544ed54f.png";